<template>
	<div>
		<banner></banner>
		<div class="grayBg pb20">
			<div class="rgfwTit rgfwTitCur">
				<div class="rgfwTit1">
					<em>域名<br>解析</em>
					<h2>高级版DNS</h2>
					<b>（防护：20万QPS）</b>
					<p>适用于展示性的企业官方网站</p>
					<a></a>
					<!-- hover后展示的部分,默认隐藏 -->
					<section class="none">
						<em>域名<br>解析</em>
						<h3>高级版DNS</h3>
						<p>国内多线BGP机房，海外多节点集群部署。超大抗攻击服务机群，有效抵抗恶意DNS攻击，秒级识别及响应攻击。</p>
						<b>¥120.00/年</b>
						<a :href="'/domain/app-detail/'+MatchProId['ENTERPRICE_DNS']">查看详情</a>
					</section>
				</div>
				<div class="rgfwTit2">
					<em>增值<br>应用</em>
					<h2>whois信息保护</h2>
					<p>保护您的个人信息不被公开</p>
					<a></a>
					<!-- hover后展示的部分,默认隐藏 -->
					<section class="none">
						<em>增值<br>应用</em>
						<h3>whois信息保护</h3>
						<p>适用于不愿意公开个人隐私信息的用户；深受垃圾邮件困扰的个人及公司域名持有者；担心真实信息被非法盗用的用户</p>
						<b>¥5.00/次开启</b>
						<a :href="'/domain/app-detail/'+MatchProId['WHOIS']">查看详情</a>
					</section>
				</div>
				<div class="rgfwTit3">
					<em>增值<br>应用</em>
					<h2>域名安全锁</h2>
					<p>有效避免恶意篡改信息或转移</p>
					<a></a>
					<!-- hover后展示的部分,默认隐藏 -->
					<section class="none">
						<em>增值<br>应用</em>
						<h3>域名安全锁</h3>
						<p>可以有效的保护域名的注册信息和域名安全，避免恶意修改或错误修改。需要通过身份验证后，才能对域名做相关修改。</p>
						<b>¥5.00/次开启</b>
						<a :href="'/domain/app-detail/'+MatchProId['DOMAIN_SECRURITY_LOCK']">查看详情</a>
					</section>
				</div>
			</div>
			<h2 class="ytit">人工服务</h2>
			<div class="w1200 pinpaifw">
				<ul>
					<li>
						<b>实名制认证</b>
						<p>协助您完成繁琐的域名实名制审核资料提交。</p>
						<div class="ljbuy">
							<span>￥
								<em>20</em>.00/次</span>
							<a :href="'/domain/app-detail/'+MatchProId['MANMADE_REALNAME']">立即购买</a>
						</div>
					</li>
					<li>
						<b>域名解析调整</b>
						<p>协助完成域名解析的增、删、改的调整，每次调整10条以内。</p>
						<div class="ljbuy">
							<span>￥
								<em>15</em>.00/次</span>
							<a :href="'/domain/app-detail/'+MatchProId['MANMADE_DOMAIN_RESOLUTION']">立即购买</a>
						</div>
					</li>
					<li>
						<b>域名DNS修改</b>
						<p>按照您的要求，协助您修改域名DNS服务器。</p>
						<div class="ljbuy">
							<span>￥
								<em>10</em>.00/次</span>
							<a :href="'/domain/app-detail/'+MatchProId['MANMADE_MODIFY_DNS']">立即购买</a>
						</div>
					</li>
					<li>
						<b>域名所有人过户</b>
						<p>域名所有人过户业务，包含一次实名制认证人工代办服务。</p>
						<div class="ljbuy">
							<span>￥
								<em>30</em>.00/次</span>
							<a :href="'/domain/app-detail/'+MatchProId['MANMADE_PASS_DOMAIN']">立即购买</a>
						</div>
					</li>
				</ul>
			</div>
			<recommend></recommend>
		</div>
	</div>
</template>
<script>
import banner from './components/header'
import recommend from './components/recommend'
import cTitle from './components/title'
import * as $_MatchProId from '../static/scripts/product-id.const'

export default {
	data () {
		return {
			MatchProId: $_MatchProId,
			isShowMore: false
		}
	},
	components: {
		banner,
		recommend,
		cTitle
	}
}
</script>
<style  lang="scss">
@import '../static/css/company-service.scss';
</style>



// WEBPACK FOOTER //
// src/company-service.vue